
import React, {useState, useEffect, useContext} from "react";
import { Form, Spinner } from "react-bootstrap";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import InlineEditor from '@ckeditor/ckeditor5-build-inline';
import { Box, Button, Paper, Typography, Fade } from "@mui/material";
import { Circle } from "../components/Circle";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import LoadingModal from "../components/LoadingModal";
import { v4 as uuidv4 } from 'uuid';
import Cookies from "js-cookie";
import './style.css'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import axios from "axios";
import DownloadDocxButton from "../components/DownloadDocx";
import { API } from "../../../controller/api";
import FileUploader from "../components/FileUploader";
import { DrawerContext } from "../../../controller/context/DrawerWidthContext";
import { useLocation, useNavigate } from "react-router-dom";



export const ResumeReviewer = (props)=>{
    const { drawerWidth } = useContext(DrawerContext);
const navigate = useNavigate();    
const location = useLocation();
    const state = location.state;
const [editorContent, setEditorContent] = useState([]);
const [loading, setLoading] = useState(true)
const [documentType, setDocumentType] = useState('')
const [documentTitle, setDocumentTitle] = useState('')
const [openModal, setOpenModal] = useState(false);
const [showDelete, setShowDelete] = useState(false);
const [data, setData] = useState([])
const user = JSON.parse(Cookies.get('user'));
    const userId = user.id;
    const token = Cookies.get('token');
    
const [update, setUpdate] = useState(false)
const [job, setJob] = useState(false)
const [jobTitle, setJobTitle] = useState('')
const [jobPost, setJobPost] = useState()
const [text, setText] = useState('');
const [resumes, setResumes] = useState([])
const [loadSelect, setLoadSelect] = useState(true)
const [documentHtml, setDocumentHtml] = useState('')

   useEffect(() => {
                const generateHtml = () => {
                  const htmlString = editorContent
                    .map(
                      (content) => `
                        <div style="margin-top: 16px; padding: 16px; border: 1px solid #ddd;">
                          <p style="font-weight: bold;">Name: <span>${content.name}</span></p>
                          <p style="font-weight: bold;">Ranking: <span>${content.ranking}</span></p>
                          <div>${content.explanation}</div>
                        </div>
                        <divider/>
                      `
                    )
                    .join(''); // Combine all generated HTML into one string
                  return htmlString;
                };
            
                setDocumentHtml(generateHtml());
              }, [editorContent]); // Runs whenever editorContent changes
            

  const handleAddResume = (resume)=>{
    
    setResumes([...resumes, resume])
    setText('')

    console.log(resumes)

  }
  
const handleBack = ()=>{
const check = window.confirm('If you choose to go back your job post will not be saved. Are you sure you would like to do this?')
if(check){
    
setLoading(true);
setDocumentType('');

}
}

const setupJobPost = (e)=>{
    let value;
    console.log(value)
    if(e.target.value === 'ANJ'){

        setJob(e.target.value)
    } else { 
       value = e.target.value;

       console.log(value)
       

   
        setJobPost(value)
    }
    

 
}

const handleDeleteResume = (resumeId) => {
    setResumes(resumes.filter(resume => resume.id !== resumeId));
};

useEffect(()=>{
   
    const fetchData = async ()=>{

        const response = await axios.post(`${API}/auth/refresh-user`, { token });
     

        setData(response.data.user.documents);

console.log(response.data.user.documents)
        setLoadSelect(false)
    }
    fetchData();
},[update])


const [response, setResponse] = useState('');

const compareResume = () => {
    setOpenModal(true);

    const getData = async () => {
        if (!jobPost && job !== 'ANJ') {
            alert('Please provide a job post or job title.');
            setOpenModal(false);
            return;
        }

        if (resumes.length === 0) {
            alert('Please upload at least one resume.');
            setOpenModal(false);
            return;
        }

        try {
            const responses = await Promise.all(
                resumes.map(async (resume) => {
                    const prompt = `
                    Act as a Human Resources expert. Compare the following resume with the job posting and provide a ranking out of 10. 
                    Include the person's name, ranking, and a nicely formatted explanation in HTML. 
                    Ensure the explanation includes pros and cons that pertain specifically to the resume.

                    Return the response in this JSON structure:
                    {
                      "name": "person's name",
                      "ranking": "ranking (number only 1-10",
                      "explanation": "<html with explanation, pros, and cons do not include any <html> or <body> tags or any heading texts just the content in <p> tags>"
                    }
                    
                    Resume: ${resume.text}
                    Job Title/Post: ${jobTitle || jobPost}
                    `;

                    const response = await axios.post(API + '/chat/create-document', { request: prompt });

                    // Extract the JSON part of the response using a regex
                    const trimmedResponse = response.data.match(/{[\s\S]*}/);
                    if (trimmedResponse) {
                        return JSON.parse(trimmedResponse[0]);
                    } else {
                        console.error('No valid JSON found in the response:', response.data);
                        throw new Error('Invalid response format');
                    }
                })
            );
            const sortedResponses = responses.sort((a, b) => b.ranking - a.ranking);
            // Format and set the trimmed responses
            setEditorContent(sortedResponses);

            console.log(responses);
            setOpenModal(false);
            setLoading(false);
        } catch (error) {
            console.error('Error processing resumes:', error);
            alert('Something went wrong. Please try again.');
            setOpenModal(false);
        }
    };

    getData();
};



if(loading) {
    return (
   <Paper sx={{ p: 2, display: "flex", flexDirection: "column", marginLeft: drawerWidth === 0 ? 38 : 0,  marginTop: 10  }}>
  
          <div style={{padding:'20px'}}>
            <Box>

          
         <Container>
         <div>
         <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="1" Color="#FD7400"/>&nbsp; &nbsp; Upload Resume</b></Typography><br/>
            <Typography sx={{marginTop:'10px'}} variant="subtitle2">Please upload the resume.(Docx or PDF)</Typography>
         <br></br>
         <Row xs={1} md={2}>
    
         <FileUploader
         SetText={setText}
         Text={text}
         handleAdd={()=>handleAddResume(text)}
         />

         
    
      </Row>
      {resumes.length > 0 && (
                        <div style={{ marginTop: '20px' }}>
                            <Typography variant="button" sx={{ fontSize: '16px' }}><b>Uploaded Resumes</b></Typography><br />
                            <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr>
                                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Resume Name</th>
                                        <th style={{ border: '1px solid #ddd', padding: '8px' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resumes.map((resume) => (
                                        <tr key={resume.id}>
                                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>{resume.fileName}</td>
                                            <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                                <Button
                                                    variant="outlined"
                                                    color="error"
                                                    onClick={() => handleDeleteResume(resume.id)}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
      </div>
      <div className="mt-5">
      <Typography  variant="button" sx={{fontSize:'16px', marginTop:5}}><b><Circle Title="2" Color="#FD7400"/>&nbsp; &nbsp; Select Job</b></Typography><br/>
            <Typography sx={{marginTop:'10px'}} variant="subtitle2">You can select a job from a job post you have created in the <b>Job Post Writer, Job Description Writer, Interview Question Writer</b> or add a new title by selecting <b>ADD NEW JOB</b>.</Typography>
            <Row className="mt-3" xs={1} md={2}>
    {loadSelect && <Spinner animation="border" variant="primary" />}
  {!loadSelect && <Form.Select 
   defaultValue={'---'}
   onChange={(e)=>{setupJobPost(e); setJob(e.target.value)}}
   >
  
    <option>---</option>
    <option value='ANJ'>ADD NEW JOB</option>
    <optgroup label="Job Post Writer">
    {data?.jobPosts.map(i=>{
        return <option>{i.documentName}</option>
    })}
    </optgroup>
    <optgroup label="Job Description Writer">
    {data?.jobDescriptions.map(i=>{
        return <option>{i.documentName}</option>
    })}
    </optgroup>

    <optgroup label="Interview Question Writer">
    {data?.interviewQuestions.map(i=>{
        return <option>{i.documentName}</option>
    })}
    </optgroup>
   </Form.Select>
}
 </Row>
 </div>
 <Fade  in={job === 'ANJ' ? 'block': 'none'}>
 <div style={{display: job === 'ANJ' ? 'block': 'none'}} className="mt-5">
 

         <Typography variant="button" sx={{fontSize:'16px'}}><b><Circle Title="3" Color="#FD7400"/>&nbsp; &nbsp; JOB TITLE</b></Typography><br/>
            <Typography sx={{marginTop:'10px'}} variant="subtitle2">Enter in the Job Title you would like to compare this resume with.</Typography>
         <br></br>
         <Row xs={1} md={2}>
    
        <Form.Control value={jobTitle} onChange={(e)=>{setJobTitle(e.target.value)}} />
    
      </Row>
 
      </div>
      </Fade> 
 
      </Container>
           


            </Box>
            
            <br></br>
            <div style={{textAlign:'right', display:documentType !== '---'?'block': 'none'}}>
            <Button sx={{marginTop:1, backgroundColor:'#0172C0'}} variant="contained" onClick={compareResume}><b>Compare</b></Button>
            </div> 
          <LoadingModal
          Open={openModal}
         
          />
       
        </div>
        </Paper>
    )
} else {
    
    return (
        <div style={{ overflowY: "auto", maxHeight: "100vh", paddingBottom: 100, marginTop: 80 }}>

            <Box sx={{marginBottom:'10px'}}>
            <Button variant="contained" onClick={handleBack}><ArrowBackIosNewIcon/> <b>BACK</b></Button>            
            <DownloadDocxButton htmlContent={documentHtml} docName={job} />
            <Button onClick={async()=>{
                 let object = {
                    id:uuidv4(),
                    dateCreated: new Date(),
                    documentName: job,
                    content: editorContent
                }
              console.log(state.route)
           const response = await  axios.post(`${API}/${state.route}/save`,{userId: userId, object:object})
           if(response.data === "Saved"){
              navigate('/dc', {state:{route: 'resume-reviewer'}})
           } else {
            window.alert('Something went wrong. Please try again.')
           }
                }} sx={{marginLeft:'10px', float:'right', display:showDelete ? 'none':'inline'}}  variant="contained"><b>SAVE</b></Button>
            </Box>
            <Paper sx={{ p: 2, marginTop: 2 }}>
  <Typography variant="h6"><b>Resume Comparison Results</b></Typography>
  {editorContent.length > 0 ? (
    editorContent.map((content, index) => (
      <Box key={index} sx={{ marginTop: 2, padding: 2, border: '1px solid #ddd' }}>
        <Typography variant="subtitle1"><b>Name:</b> {content.name}</Typography>
        <Typography variant="subtitle2"><b>Ranking:</b> {content.ranking}</Typography>
        <Typography variant="body1" dangerouslySetInnerHTML={{ __html: content.explanation }} />
      </Box>
    ))
  ) : (
    <Typography>No results to display.</Typography>
  )}
</Paper>
    </div>
)

}
}